import React from 'react';
import { Typography } from '@mui/material';
import CounterpartyTable from './counterpartyTable/counterpartyTable.component';
import {
  buildDerivativeExposureAvailableLiquidityRatio,
  buildDerivativeVarData,
  buildLiquidationDistanceData,
  buildPositionVarData,
  counterpartyAvailableLiquidityColumns,
  counterpartyLiquidationColumns,
  counterpartyVarExposureColumns,
} from './tableDisplay.data';
import DisplayAreaCenteredWrapper from '../../../../layout/utilities/displayAreaWrapper';
import { LasdabCplRiskReport } from '../../lasdab/lasdab.types';

interface CounterpartyTableDisplayProps {
  data: LasdabCplRiskReport;
}

const CounterpartyTableDisplay = (props: CounterpartyTableDisplayProps) => {
  const dataForUse = props.data;
  if (!dataForUse) {
    return (
      <DisplayAreaCenteredWrapper>
        <Typography variant="h1">No Data Available.</Typography>
      </DisplayAreaCenteredWrapper>
    );
  }

  const counterpartyRisk = dataForUse.counterparty_risk as
    | { cpName: string[]; cpId: string[] }
    | undefined;
  if (!counterpartyRisk?.cpName?.length) {
    return (
      <DisplayAreaCenteredWrapper>
        <Typography variant="h1">No Data Available.</Typography>
      </DisplayAreaCenteredWrapper>
    );
  }

  const counterpartyNames = counterpartyRisk.cpName;
  const counterpartyIds = counterpartyRisk.cpId;

  const EXPOSURE_EXPORT_COLS = [
    'counterparty',
    'equity',
    'commodity',
    'fixedIncome',
    'cash',
    'alternative',
    'total',
  ];

  return (
    <>
      <CounterpartyTable
        xl={7}
        data={buildPositionVarData(
          counterpartyIds,
          counterpartyNames,
          dataForUse.cp_position_var_data,
        )}
        columns={counterpartyVarExposureColumns}
        exportColumns={EXPOSURE_EXPORT_COLS}
        title="Position VaR Exposure"
      />
      <CounterpartyTable
        xl={5}
        data={buildLiquidationDistanceData(
          counterpartyIds,
          counterpartyNames,
          dataForUse.cp_position_var_data?.liquid,
        )}
        columns={counterpartyLiquidationColumns}
        title="Liquidation Distance"
        exportColumns={['counterparty', 'assetValue', 'liquidationDistance']}
      />
      <CounterpartyTable
        xl={7}
        data={buildDerivativeVarData(
          counterpartyIds,
          counterpartyNames,
          dataForUse.cp_derivative_var_data,
        )}
        exportColumns={EXPOSURE_EXPORT_COLS}
        columns={counterpartyVarExposureColumns}
        title="Derivative VaR Exposure"
      />
      <CounterpartyTable
        xl={5}
        exportColumns={[
          'counterparty',
          'liquidity',
          'var',
          'cpRatio',
          'fundRatio',
        ]}
        data={buildDerivativeExposureAvailableLiquidityRatio(
          dataForUse.cp_derivative_var_data,
          counterpartyNames,
          counterpartyIds,
        )}
        columns={counterpartyAvailableLiquidityColumns}
        title="Derivative Exposure Available Liquidity Ratio"
      />
    </>
  );
};

export default CounterpartyTableDisplay;
